import { apiClient, getJson, patchJson, postJson } from '@/lib/apiClient';
import type { MdmCluster, ResolveDatasetInput } from '@/features/mdm/types';

interface Wrapped<T> {
  data: T;
}

export interface ClusterFilters {
  status?: string;
  source?: string;
}

export const mdmApi = {
  clusters: (filters: ClusterFilters): Promise<MdmCluster[]> =>
    getJson<Wrapped<MdmCluster[]>>('/mdm/clusters', {
      status: filters.status,
      source: filters.source,
    }).then((r) => r.data),

  resolveDataset: (datasetId: string, input: ResolveDatasetInput): Promise<MdmCluster[]> =>
    postJson<Wrapped<MdmCluster[]>>(`/mdm/datasets/${datasetId}/resolve`, input).then((r) => r.data),

  updateGolden: (id: string, golden: Record<string, unknown>): Promise<MdmCluster> =>
    patchJson<Wrapped<MdmCluster>>(`/mdm/clusters/${id}/golden`, { golden_record: golden }).then(
      (r) => r.data,
    ),

  approve: (id: string): Promise<MdmCluster> =>
    postJson<Wrapped<MdmCluster>>(`/mdm/clusters/${id}/approve`).then((r) => r.data),

  reject: (id: string): Promise<MdmCluster> =>
    postJson<Wrapped<MdmCluster>>(`/mdm/clusters/${id}/reject`).then((r) => r.data),

  clearAll: (status?: string): Promise<{ deleted: number }> =>
    apiClient
      .delete<{ deleted: number }>('/mdm/clusters', { params: { status } })
      .then((r) => r.data),
};

export const mdmKeys = {
  clusters: (filters: ClusterFilters) => ['mdm', 'clusters', filters] as const,
};
